module.exports = __webpack_public_path__ + "_config/locale/supported-locales.json";